module.exports = __webpack_public_path__ + "img/micphone.1153053a.svg";